/** @jsx jsx */
// TODO: remove eslint statement when 'css' is implemented
import { jsx } from '@emotion/react';
// eslint-disable-next-line no-unused-vars
import React from 'react';
import { PropertyListSelector } from 'components/selectors/propertyListSelector';
import { LimitSelector } from 'components/selectors/limitSelector';
import {Tab, Tabs} from "@blueprintjs/core";

/**
 * Custom renderer for the controls available to change the chart settings.
 *
 * Data Properties for this Widget:
 *   -- propertyList
 *   -- limit
 *
 * Chart Properties for this Widget:
 *
 * @param cardIndex
 * @param endpointQuery
 * @param flags
 * @param types
 * @returns {*}
 * @constructor
 */
export const CirclePackKnobs = ({ cardIndex, endpointQuery, flags, types }) => {
	return (
		<Tabs>
			<Tab id="data" title="Data" panel={
				<React.Fragment>
					<PropertyListSelector
						cardIndex={cardIndex}
						itemIndex={0}
						types={types}
						flags={flags}
						label={'Group By'}
						endpointQuery={endpointQuery}
						cy-test="group-by-dropdown-button"
					/>
					<LimitSelector
						cardIndex={cardIndex}
						endpointQuery={endpointQuery}
						initialLimit={50}
						label={'Root Count'}
						limitProperty="maxRoot"
						cy-test="root-count-dropdown-button"
					/>
					<LimitSelector
						cardIndex={cardIndex}
						endpointQuery={endpointQuery}
						initialLimit={1000}
						label={'Child Count'}
						limitProperty="maxChildren"
						cy-test="child-count-dropdown-button"
					/>
				</React.Fragment>
			} />
			<Tab id="style" title="Style" panel={
				<React.Fragment>
					<div>Some style stuff goes here</div>
				</React.Fragment>
			} />
		</Tabs>
	);
};
